export const TODO_ACTIONS = {
    CREATE: 'CREATE',
    TOGGLE: 'TOGGLE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE'
}

export const VISIBILITY_FILTER_TYPES = {
    ALL: 'all',
    OPEN: 'open',
    DONE: 'done'
}

export const VISIBILITY_FILTER_ACTIONS = {
    SET: 'SET'
}
